import React from "react";
import "./Footer.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        <a
          href="https://github.com/AtulyaJaiswal"
          target="_blank"
          rel="noreferrer">
          <GitHubIcon style={{ fontSize: "2rem", color: "white" }} />
        </a>
        <a
          href="https://www.linkedin.com/in/atulyajaiswal/"
          target="_blank"
          rel="noreferrer">
          <LinkedInIcon style={{ fontSize: "2rem", color: "#008cff" }} />
        </a>
        <a
          href="https://www.instagram.com/atulyajaiswal/"
          target="_blank"
          rel="noreferrer">
          <InstagramIcon
            style={{ fontSize: "2rem", color: "rgb(212, 12, 105)" }}
          />
        </a>
        <a
          href="https://twitter.com/AtulyaJaiswal22"
          target="_blank"
          rel="noreferrer">
          <TwitterIcon style={{ fontSize: "2rem", color: "#008cff" }} />
        </a>
        <a
          href="mailto:jaiswalatulya.aj@gmail.com"
          target="_blank"
          rel="noreferrer">
          <EmailIcon style={{ fontSize: "2rem", color: "white" }} />
        </a>
      </div>
      {/* <div className='footer-right'>
      <a href="mailto:jaiswalatulya.aj@gmail.com">
              <p>jaiswalatulya.aj@gmail.com</p>
            </a>
      </div> */}
    </div>
  );
};

export default Footer;
